import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const planificacionImporterSelectors = importerSelectors(
  'planificacion.importer',
);

export default planificacionImporterSelectors;
